import {
  formatter as dateTimeFormatter,
  isGreater,
  isLess,
} from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';

const defaultManager = {
  format: value => value,
  sortComparer: (valueA, valueB) => {
    if (valueA < valueB) {
      return -1;
    }

    if (valueA > valueB) {
      return 1;
    }

    return 0;
  },
};

const dateTime = {
  format: (value, timeZone = null) => dateTimeFormatter(value, formats.CHART, timeZone),
  sortComparer: (dateStringA, dateStringB) => {
    if (isGreater(dateStringA, dateStringB)) {
      return 1;
    }
    if (isLess(dateStringA, dateStringB)) {
      return -1;
    }
    return 0;
  },
};

/**
 * Gerenciadores de dados registrados.
 */
const dataManagers = {
  default: defaultManager,
  dateTime,
};

/**
 * Gerenciador de dados
 * @typedef {Object} DataManager
 * @property {Function} format função responsável por formatar os dados.
 * Assinatura: (ViewModel, valor) => valor.
 * @property {Function} sortComparer Função comparadora para ordenação de listas (Array.sort).
 */

/**
 * Retorna um gerenciador de dados.
 * O gerenciador de dados tem a função de formatar os valores para exibição e saber como ordena-los.
 * @param {String|DataManager} [dataManagerConfig=default] Gerenciador de dados que está sendo
 * solicitado. Se o parametro dor um objeto, o mesmo será retornado, assumindo que é um gerenciador
 * customizado.
 * @returns {DataManager}
 */
export default (dataManagerConfig) => {
  if (typeof dataManagerConfig === 'object') {
    return dataManagerConfig;
  }

  if (!dataManagerConfig) {
    return dataManagers.default;
  }

  if (!dataManagers[dataManagerConfig]) {
    throw new Error(`Data manager desconhecido: ${dataManagerConfig}`);
  }

  return dataManagers[dataManagerConfig];
};
